module.exports = "<!-- 土砂災害危険度メッシュポップアップテンプレートHTML -->\n<div style=\"color:#FF0000\"><b>土砂災害危険度判定図</b></div>\n%content%\n"